'use strict';

function CompanyFlowVerifiesService($resource, config) {
  return $resource(config.apiBase + '/companies/:companyId/flow-verifies/:flowVerifyID', {}, {
    'update': {
      method: 'PUT'
    }
  });
}

angular.module('dokiv')
  .factory('CompanyFlowVerifiesService', ['$resource', 'config', CompanyFlowVerifiesService]);


//////////////////
// WEBPACK FOOTER
// ./scripts/company/account/CompanyFlowVerifiesService.js
// module id = 36
// module chunks = 0